<template>
  <div class="WARN -moto-maintenance">
    <div class="-info-box">
      <div class="-message">
        <div class="-text">Scheduled maintenance starts in</div>
        <div class="-countdown" v-text="timeLeftString" />
      </div>
    </div>
    <slot name="closeItemSlot" :closeItem="closeItem" />
  </div>
</template>

<script>
import CommonMessageInterface from 'v/notification/CommonMessageInterface.vue';
import moment from 'moment';

const HOUR = 60 * 60 * 1e3;

export default CommonMessageInterface.extend({
  name: 'MotoMaintenance',
  data() {
    return {
      now: Date.now(),
    };
  },

  computed: {
    timeLeftString() {
      const timeLeft = this.msg.lockTimestamp - this.now;
      return timeLeft > 1e3
        ? moment.utc(timeLeft).format(timeLeft > HOUR ? 'h:mm:ss' : 'm:ss')
        : 'NOW';
    },
  },

  onBeforeDestroy() {
    window.clearInterval(this._interval);
  },

  mounted() {
    this._interval = setInterval(() => {
      this.now = Date.now();
    }, 1e3);
  },
});
</script>

<style lang="scss">
.wt2-notification-feedback > .-item.-moto-maintenance {
  .-message {
    display: flex;
    .-text {
      flex-grow: 1;
      align-self: center;
      text-align: center;
      font-size: 20px;
    }
    .-countdown {
      flex-shrink: 1;
      font-weight: 700;
      font-size: 40px;
      padding-right: 2rem;
    }
  }
}
</style>
